import type { CartLineItem } from 'types/cart/CartLineItem';
import type { CartLineItemWithServings } from 'types/cart/CartLineItemWithServings';
import type { ShopifyProduct } from 'types/product/ShopifyProduct';

import {
  hasSellingPlan,
  hasServings,
  hasSingleVariant,
  isOneTimePurchase,
  isOtpMultiVariant,
  isOtpSingleVariant,
} from './typeInference';

export const getSubtitle = (
  lineItem: CartLineItem | CartLineItemWithServings,
  shopifyProduct: ShopifyProduct | undefined,
) => {
  if (isOtpSingleVariant(shopifyProduct)) return '';
  if (isOtpMultiVariant(shopifyProduct)) return lineItem.merchandise.title;
  return isOneTimePurchase(lineItem) ? 'One-time purchase' : 'Subscription';
};

export const getSelectorSubtitle = (
  lineItem: CartLineItem | CartLineItemWithServings,
  shopifyProduct: ShopifyProduct | undefined,
) => {
  if (
    hasSingleVariant(shopifyProduct) &&
    !hasSellingPlan(shopifyProduct.variants[0])
  ) {
    return '';
  }
  if (!hasServings(lineItem.merchandise)) return '';
  return isOneTimePurchase(lineItem)
    ? `${lineItem.merchandise.title} delivered once`
    : lineItem.sellingPlanAllocation?.sellingPlan.title;
};
